import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import {
    PersonaType,
    GetPersonaRequest,
    GetPersonaJsonResponse,
    getServiceAsync,
} from '../../../../service';
import { runOwsRequestWithMonitor, Feature, fullResponseOperationOption } from '../../..';

export function getOwsPersona(
    personaId: string,
    contactFolderId: string,
    additionalLogProperties?: {}
): Promise<PersonaType> {
    return getServiceAsync().then(service => {
        let request: GetPersonaRequest = service.Factory.getPersonaRequest({
            PersonaId: service.Factory.itemId({ Id: personaId }),
        });

        // Parent folder is needed for Public Folders
        if (contactFolderId) {
            request.ParentFolderId = service.Factory.targetFolderId({
                BaseFolderId: service.Factory.folderId({ Id: contactFolderId }),
            });
        }

        return runOwsRequestWithMonitor({
            scenarioName: 'GetPersona',
            feature: Feature.ContactManagement,
            operation: () =>
                service.Operation.getPersonaOperation(
                    {
                        Header: getJsonRequestHeader(),
                        Body: request,
                    },
                    fullResponseOperationOption
                ),
            qoSConfig: additionalLogProperties && {
                additionalQoSLogProperty: additionalLogProperties,
            },
            transformResponse: (response: GetPersonaJsonResponse) => response.Body.Persona,
        });
    });
}

export function getOwsPersonaByEmail(
    email: string,
    additionalLogProperties?: {}
): Promise<PersonaType> {
    return getServiceAsync().then(service => {
        const request: GetPersonaRequest = service.Factory.getPersonaRequest({
            EmailAddress: { EmailAddress: email },
        });

        return runOwsRequestWithMonitor({
            scenarioName: 'GetPersonaByEmail',
            feature: Feature.ContactManagement,
            operation: () =>
                service.Operation.getPersonaOperation(
                    {
                        Header: getJsonRequestHeader(),
                        Body: request,
                    },
                    fullResponseOperationOption
                ),
            qoSConfig: additionalLogProperties && {
                additionalQoSLogProperty: additionalLogProperties,
            },
            transformResponse: (response: GetPersonaJsonResponse) => response.Body.Persona,
        });
    });
}
